import React from 'react'
import { useDispatch } from 'react-redux'
import { logout } from 'actions/authenticationActions'

interface IInputDataProps {
  match: { params: { opportunityId: string } }
}

const Logout = ({ match }: IInputDataProps) => {
  let opportunityId = match.params.opportunityId
  const dispatch = useDispatch()
  //delete data
  dispatch(logout())
  //direct to login
  if (opportunityId) {
    window.location.href = '/login?oppId=' + opportunityId
  } else {
    window.location.href = '/login?oppId='
  }

  return null
}

export default Logout
